import React, { useEffect, useState } from "react";
import {
  Typography,
  Paper,
  Box,
  CircularProgress,
  Container,
  Link,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { activateSubscription } from "../../utils/subscriptionUtils";
import LoadingComponent from "../../components/LoadingComponent/LoadingComponent";

const NotifyActivated = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [queueId, setQueueId] = useState("");
  const [showProcessing, setShowProcessing] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const activateSubscriptionAsync = async () => {
      try {
        const response = await activateSubscription();
        setQueueId(response);
        setShowProcessing(true);
      } catch (error) {
        console.error("Error:", error);
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    };

    activateSubscriptionAsync();
  }, []);

  // Loading state
  if (isLoading) {
    return (
      <Container
        maxWidth="sm"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "50vh",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <CircularProgress size={60} sx={{ mb: 2 }} />
          <Typography variant="h6">{t("notifyActivated.loading")}</Typography>
        </Box>
      </Container>
    );
  }

  // Processing state
  if (showProcessing) {
    return (
      <Container maxWidth="sm">
        <LoadingComponent queueId={queueId} callback={setShowProcessing} />
      </Container>
    );
  }

  // Error state
  if (error) {
    return (
      <Container maxWidth="sm">
        <Paper
          elevation={3}
          sx={{
            p: 3,
            textAlign: "center",
            backgroundColor: (theme) => theme.palette.error.light,
            color: (theme) => theme.palette.error.contrastText,
          }}
        >
          <Typography variant="h5" gutterBottom>
            {t("notifyActivated.errorTitle")}
          </Typography>
          <Typography variant="body1">
            {t("subscription.subscriptionError")}
          </Typography>
          <Box sx={{ pt: 2, display: "flex", justifyContent: 'center' }}>
            <Typography sx={{ pr: 1 }} variant="body1">
              {t("support.haveQuestions")}
            </Typography>
            <Link
              target="_blank"
              href={process.env.REACT_APP_SUPPORT_PAGE}
              variant="body1"
            >
              {t("support.visitSite")}
            </Link>
          </Box>
        </Paper>
      </Container>
    );
  }

  // Success state
  return (
    <Container maxWidth="sm">
      <Paper
        elevation={3}
        sx={{
          p: 4,
          textAlign: "center",
        }}
      >
        <Typography variant="h4" color="primary" gutterBottom>
          {t("notifyActivated.title")}
        </Typography>
        <Typography variant="body1" component={"p"} align="justify">
          {t("notifyActivated.message1")}
        </Typography>
        <Typography variant="body1" align="justify">
          {t("notifyActivated.message2")}
        </Typography>
        <Box sx={{ pt: 2, display: "flex", justifyContent: 'center' }}>
            <Typography sx={{ pr: 1 }} variant="body1">
              {t("support.haveQuestions")}
            </Typography>
            <Link
              target="_blank"
              href={process.env.REACT_APP_SUPPORT_PAGE}
              variant="body1"
            >
              {t("support.visitSite")}
            </Link>
          </Box>
      </Paper>
    </Container>
  );
};

export default NotifyActivated;
